import React from 'react';
import { useFormField } from '../../core';
import { TextArea } from '@/ui-kit';
import { usePreFilledFieldValidation } from '../../hooks';

type InputTextAreaProps = {
  label: string;
  name: string;
  placeholder?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
};

export const InputTextArea: React.FC<InputTextAreaProps> = ({
  label,
  ...props
}) => {
  const [field, meta] = useFormField(props);

  const error = meta.touched ? meta.error : undefined;

  usePreFilledFieldValidation(field, meta.touched);

  return (
    <TextArea
      label={label}
      id={field.name}
      {...field}
      {...props}
      value={field.value as string | undefined}
      state={error ? 'error' : 'default'}
      stateText={error}
    />
  );
};
